import React from 'react';
import MapViewControl from './MapView.Control.jsx';
import * as L from "leaflet";

import ExtraMarkers from 'leaflet-extra-markers';

import { MapContainer, TileLayer, Marker, Popup, Polyline, FeatureGroup, useMap, Tooltip } from 'react-leaflet'
function getLineColour(distance) {
    switch (distance) {
        case 50:
            return "#ff99cc";
        case 100:
            return "#99ccff";
        case 150:
            return "#cc99cc";
        case 200:
            return "#d83c3d";
        case 300:
            return "#ffcc00";
        case 400:
            return "#339933";
        case 600:
            return "#006699";
        case 1000:
            return "#999999";
        default:
            return "#000000";
            break;
    }
}

export default function MapViewStart(props) {
    const parentMap = useMap();

    var ride = props.ride;
    var isSelected = props.isSelected;
    var marker = null;

    for (let i = 0; i < ride.Checkpoints.length; i++) {
        var checkPointData = ride.Checkpoints[i];
        var myPoint = [checkPointData.Point.Latitude, checkPointData.Point.Longitude];
        if (checkPointData.Type == 0 || checkPointData.Type == 3) {
            var setting = {
                icon: 'fa-play',
                markerColor: getLineColour(ride.NominalDistance),
                shape: 'circle',
                prefix: 'fa',
                extraClasses: "g-pl-5",
                svg:true
            };

            marker = L.ExtraMarkers.icon(setting);
        } 
    }
    if(marker == null){
        console.log("No start found: ", ride);
        return null;
    }
    var viewControl = null;
    if (isSelected) {
        viewControl = <MapViewControl ride={ride} close={props.close} />;
    }
    return (
        <FeatureGroup   key={ride.Id} eventHandlers={{ click: (evt) => props.open(evt, ride.Id), popupclose: props.close }}>
            {viewControl}
            <Marker position={myPoint} icon={marker}>  <Tooltip>
                   {ride.Name}  ({ride.NominalDistance}Km)
                </Tooltip>
            </Marker>
        </FeatureGroup>);

}
